/**
 * TBD
 * Product Area: OPEN_WITH_FAIRE
 */
export const OPEN_WITH_FAIRE_OFFERED_TERMS = 'OPEN_WITH_FAIRE_OFFERED_TERMS';
